module.exports = __webpack_public_path__ + "img/home-empresas-2.304315b.webp";